module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sign-up"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container', [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [(_vm.signInType === 'signup') ? _c('h1', [_vm._v("Create a profile")]) : _vm._e(), _vm._v(" "), (_vm.signInType === 'login') ? _c('h1', [(_vm.activateRedirect) ? [_vm._v("\n          Sign In to verify your email\n        ")] : (_vm.emailChangeRedirect) ? [_vm._v("\n          Sign In to verify your change of email\n        ")] : [_vm._v("\n          Sign In to SK\n        ")]], 2) : _vm._e()]), _vm._v(" "), _c('sk-panel', [(_vm.signInType === 'signup') ? _c('div', {
    staticClass: "user-signup"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-form', {
    attrs: {
      "id": "user-signup-form"
    },
    on: {
      "submit": function($event) {
        _vm.signup()
      }
    }
  }, [_c('sk-button', {
    staticClass: "fb-login",
    attrs: {
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.loginState()
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "facebook": ""
    }
  }), _vm._v(" Create A Profile With Facebook")], 1), _vm._v(" "), _c('h4', [_vm._v("Or")]), _vm._v(" "), _c('p', {
    staticClass: "form-alert"
  }, [_vm._v("All fields are mandatory")]), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "First Name",
      "required": "",
      "error-message": {
        valueMissing: 'Please tell us your name.'
      }
    },
    model: {
      value: (_vm.User.FirstName),
      callback: function($$v) {
        _vm.$set(_vm.User, "FirstName", $$v)
      },
      expression: "User.FirstName"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Surname",
      "required": "",
      "error-message": {
        valueMissing: 'What\'s your surname?'
      }
    },
    model: {
      value: (_vm.User.LastName),
      callback: function($$v) {
        _vm.$set(_vm.User, "LastName", $$v)
      },
      expression: "User.LastName"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Email",
      "type": "email",
      "placeholder": "e.g. xxx@gmail.com",
      "autocomplete": "false",
      "required": "",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.User.Email),
      callback: function($$v) {
        _vm.$set(_vm.User, "Email", $$v)
      },
      expression: "User.Email"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Password",
      "type": "password",
      "autocomplete": "false",
      "required": "",
      "error-message": {
        patternMismatch: 'Your password must contain a minimum of 8 characters containing both numbers and letters, with at least one uppercase letter and a special character (!@#$%&).'
      },
      "pattern": "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[$@#$!%*?&])[A-Za-z\\d$@#$!%*?&]{8,}"
    },
    model: {
      value: (_vm.User.Password),
      callback: function($$v) {
        _vm.$set(_vm.User, "Password", $$v)
      },
      expression: "User.Password"
    }
  }), _vm._v(" "), _c('sk-layout', {
    staticClass: "radio-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "gender-label",
    attrs: {
      "for": "gender"
    }
  }, [_vm._v("Gender")])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Female",
      "label": "Female"
    },
    model: {
      value: (_vm.User.Gender),
      callback: function($$v) {
        _vm.$set(_vm.User, "Gender", $$v)
      },
      expression: "User.Gender"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Male",
      "label": "Male"
    },
    model: {
      value: (_vm.User.Gender),
      callback: function($$v) {
        _vm.$set(_vm.User, "Gender", $$v)
      },
      expression: "User.Gender"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('sk-radio', {
    attrs: {
      "name": "radio-gender",
      "radio-value": "Unknown",
      "label": "I'd rather not say"
    },
    model: {
      value: (_vm.User.Gender),
      callback: function($$v) {
        _vm.$set(_vm.User, "Gender", $$v)
      },
      expression: "User.Gender"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', [_vm._v("Mobile Number")])])], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.countryCodes,
      "placeholder": "Country Code",
      "validation-value": _vm.countryCode,
      "error-message": "Please choose a country code",
      "required": ""
    },
    model: {
      value: (_vm.countryCode),
      callback: function($$v) {
        _vm.countryCode = $$v
      },
      expression: "countryCode"
    }
  })], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs9": ""
    }
  }, [_c('sk-input', {
    attrs: {
      "name": "mobile",
      "placeholder": "eg. 827804800",
      "type": "tel",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your mobile number',
        patternMismatch: 'Please double check you\'ve entered 9 digits excluding your country code.'
      },
      "pattern": "^\\+?\\d{11,11}|\\d{10,10}|\\d{9,9}$"
    },
    model: {
      value: (_vm.mobilePhone),
      callback: function($$v) {
        _vm.mobilePhone = $$v
      },
      expression: "mobilePhone"
    }
  })], 1)], 1), _vm._v(" "), _c('sk-layout', {
    staticClass: "select-section",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('label', {
    staticClass: "birthday-label",
    attrs: {
      "for": "birthday"
    }
  }, [_vm._v("\n                    Birthday "), _c('sk-tooltip', {
    key: "birthday-tooltip",
    attrs: {
      "content": "Based on your age, we'll send you updates you will enjoy.",
      "standalone": ""
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "day"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.days,
      "placeholder": "Day",
      "validation-value": _vm.User._DobDay,
      "error-message": "Please choose a day",
      "required": ""
    },
    model: {
      value: (_vm.User._DobDay),
      callback: function($$v) {
        _vm.$set(_vm.User, "_DobDay", $$v)
      },
      expression: "User._DobDay"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('div', {
    staticClass: "month"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.months,
      "placeholder": "Month",
      "validation-value": _vm.User._DobMonth,
      "error-message": "Please choose a month",
      "required": ""
    },
    model: {
      value: (_vm.User._DobMonth),
      callback: function($$v) {
        _vm.$set(_vm.User, "_DobMonth", $$v)
      },
      expression: "User._DobMonth"
    }
  })], 1)]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs3": ""
    }
  }, [_c('div', {
    staticClass: "year"
  }, [_c('sk-combo-select', {
    attrs: {
      "options": _vm.years,
      "placeholder": "Year",
      "validation-value": _vm.User._DobYear,
      "error-message": "Please choose a year",
      "required": ""
    },
    model: {
      value: (_vm.User._DobYear),
      callback: function($$v) {
        _vm.$set(_vm.User, "_DobYear", $$v)
      },
      expression: "User._DobYear"
    }
  })], 1)])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [(_vm.subsClub == undefined || _vm.subsClub == null) ? _c('p', {
    staticClass: "form__suffix"
  }, [_vm._v("By creating an SK profile "), (_vm.userJoinSK) ? _c('span', [_vm._v("and joining SK Club")]) : _vm._e(), _vm._v(", you agree to our "), _c('a', {
    attrs: {
      "href": "/content/legal/online-booking-terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("Ts & Cs")]), _vm._v(" "), (_vm.userJoinSK) ? _c('span', [_vm._v("and "), _c('a', {
    attrs: {
      "href": "/content/legal/club-terms-and-conditions",
      "target": "_blank"
    }
  }, [_vm._v("SK Club Ts & Cs")]), _c('br'), _vm._v(" Want to find out more? Check out our "), _c('a', {
    attrs: {
      "href": "/faq",
      "target": "_blank"
    }
  }, [_vm._v("FAQs")]), _vm._v(". ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.subsClub != undefined && _vm.subsClub != null) ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Create a Profile to join")])] : [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Create a Profile")])], _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "form__suffix"
  }, [_vm._v("Already have an SK profile? "), _c('a', {
    attrs: {
      "href": "/user/login"
    }
  }, [_vm._v("Sign In")])])], 2)], 1)], 1) : _vm._e(), _vm._v(" "), ((_vm.signInType === 'login' || _vm.signInType === 'reset' || _vm.signInType === 'welcome' || _vm.codeActivated)) ? _c('div', {
    staticClass: "user-signup"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('sk-form', {
    attrs: {
      "id": "user-login-form",
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        _vm.login()
      }
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }, [_c('sk-button', {
    staticClass: "fb-login",
    attrs: {
      "block": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.loginState()
      }
    }
  }, [_c('sk-icon', {
    attrs: {
      "facebook": ""
    }
  }), _vm._v(" Sign In with Facebook")], 1), _vm._v(" "), _c('h4', [_vm._v("Or")]), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Email",
      "type": "email",
      "autocomplete": "false",
      "placeholder": "e.g. xxx@gmail.com",
      "required": "",
      "error-message": {
        valueMissing: 'Please make sure your email address follows this format: example@email.com'
      }
    },
    model: {
      value: (_vm.User.Email),
      callback: function($$v) {
        _vm.$set(_vm.User, "Email", $$v)
      },
      expression: "User.Email"
    }
  }), _vm._v(" "), _c('sk-input', {
    attrs: {
      "label": "Password",
      "type": "password",
      "autocomplete": "false",
      "required": "",
      "error-message": {
        valueMissing: 'Please enter your password.',
        patternMismatch: 'Your password must contain a minimum of 8 characters containing both numbers and letters, with at least one uppercase letter and a special character (!@#$%&).'
      }
    },
    model: {
      value: (_vm.User.Password),
      callback: function($$v) {
        _vm.$set(_vm.User, "Password", $$v)
      },
      expression: "User.Password"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "forgotten-password",
    attrs: {
      "href": "/user/password-reset/email"
    }
  }, [_vm._v("Forgotten your password?")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-button"
  }, [(_vm.subsClub != undefined && _vm.subsClub != null) ? [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Sign in to join")])] : [_c('sk-button', {
    attrs: {
      "primary": "",
      "type": "submit"
    }
  }, [_vm._v("Sign in")])], _vm._v(" "), _c('p', [_vm._v("Don't have an SK profile yet? "), _c('br'), _c('a', {
    attrs: {
      "href": "/user/signup"
    }
  }, [_vm._v("Create one now")])])], 2)], 1)], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dfa5d11","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/user/user.vue
// module id = 544
// module chunks = 0